import React from "react";
import styled from "styled-components";
import logo from "../../images/2025largeL.png";
import signI from "../../images/signIcon.svg";
import Navigation from "./Navigation";
import { Link } from "react-router-dom";
import { breakpoints } from "../../utils/breakpoints";

// import fb from "../../images/facebook.svg";
// import twitter from "../../images/Twitter.svg";
// import insta from "../../images/insta.svg";
// import yt from "../../images/youtube.svg";
// import shopify from "../../images/shopify.svg";
// import shopifyWhite from "../../images/WhiteShopify.svg";
// import instaWhite from "../../images/WhiteInsta.svg";
// import ytWhite from "../../images/WhiteGroup4.svg";
// import tweetWhite from "../../images/WhiteIcon.svg";
// import fbWhite from "../../images/WhiteIcon-1.svg";

const StyledHeader = styled.div`
	width: 100%;
	background: #1F232A no-repeat padding-box;
	color: white;

	.content-container {
		display: grid;
        grid-template-columns: 20% 1fr 20%;
        padding: 0 2rem;
        margin: 0 auto;
		width: auto;
		align-items: center;

		.logins {
            display: flex;
            column-gap: 20px;
            align-items: center;
			justify-content: flex-end;

            a {
                color: white;
                text-decoration: none;
                font-family: 'nexa-bold';
                
                &:visited {
                    color: white;
                }
                
                &:hover {
                    color: #44b2dd;
                }
            }

            .signs {
                display: flex;
                justify-content: center;
                column-gap: 10px;
            }

            .signinbtn {
                cursor: pointer;
                border: none;
                outline: none;
                font: normal normal normal 1vw/1vw Nexa-bold;
                color: #ffffff;
            }
        }

		.icons{
			display: flex;
			justify-content: center;
			column-gap: 15px;
			align-items: center;
		
			.iconsBottom{
				margin-right: 10px;
			}
		}

		.bigLogo {
            grid-column: 1;
            justify-self: start;
            
            .logo {
                text-align: left;
                cursor: pointer;

                img {
                    width: auto;
                    height: 50px;
                }
            }
        }

	}

	@media screen and ${breakpoints.device.laptopL} {
		padding: 2px 0;
	}

	@media screen and ${breakpoints.device.tablet} {
		padding: 2px 0;
		.content-container {
			display: flex;

			.bigLogo,
			.logins {
				display: none;
			}

			.logo {
				text-align: left;
				cursor: pointer;

				img {
					height: 10vh;
				}
			}

			.hamburger {
				margin-right: 0px;
			}
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		height: 7.5vh;
		.content-container {

			.logo {
				margin-left: 0;
				img {
					height: 7vh;
				}
			}

			.hamburger {
				margin-right: 0;
			}
		}
	}
`;

const Header = ({ setIsSubModalOpen }) => {
	//const isReplicated = true;
	const isReplicated = window.replicated;
	return (
		<StyledHeader>
			<div className="content-container">
				{/* <div className="socials" style={{visibility: 'hidden'}}>
					<div className="icons">
						<a
							href="https://www.facebook.com/iGeniusFB"
							target="_blank"
							rel="noreferrer"
							className="circles">
							<img
								className="iconsBottom"
								src={
									window.innerWidth >
									650
										? fb
										: fbWhite
								}
								alt=""
							/>
						</a>
						<a
							href="https://twitter.com/iGeniusGlobal"
							target="_blank"
							rel="noreferrer">
							<img
								className="iconsBottom"
								src={
									window.innerWidth >
									650
										? twitter
										: tweetWhite
								}
								alt=""
							/>
						</a>
						<a
							href="https://www.instagram.com/igeniusglobal/"
							target="_blank"
							rel="noreferrer">
							<img
								className="iconsBottom"
								src={
									window.innerWidth >
									650
										? insta
										: instaWhite
								}
								alt=""
							/>
						</a>
						<a
							href="https://www.youtube.com/channel/UC7ExwEwVh8D6TvqpY3zgKSg"
							target="_blank"
							rel="noreferrer">
							<img
								className="iconsBottom"
								src={
									window.innerWidth >
									650
										? yt
										: ytWhite
								}
								alt=""
							/>
						</a>
						<a
							href="https://igeniusglobal.myshopify.com/"
							target="_blank"
							rel="noreferrer">
							<img
								className="iconsBottom"
								src={
									window.innerWidth >
									650
										? shopify
										: shopifyWhite
								}
								alt=""
							/>
						</a>
					</div>
				</div> */}

				<div className="bigLogo">
					<div className="logo">
						<Link to="/">
							<img src={logo} alt="logo" />
						</Link>
					</div>
				</div>

				<Navigation
					setIsSubModalOpen={setIsSubModalOpen}
				/>
				
				{isReplicated ? 
					<div className="logins">
						<div className="signs">
							<a href="#home">
								<span
									onClick={() => {
										console.log(
											"KILROY WAS HERE?",
											setIsSubModalOpen
										);
										setIsSubModalOpen(
											true
										);
									}}
									className="signinbtn">
									Get Started
								</span>
							</a> 
						</div>
						
						<div className="signs">
							<img src={signI} />
							<a href="https://shield.igenius.biz/login.html">
								Sign In
							</a>
						</div>
					</div>
					: 
					<div className="logins">
						<div className="signs">
							<img src={signI} />
							<a href="https://shield.igenius.biz/login.html">							
								Sign In
							</a>
						</div>
					</div>
				}
			</div>
		</StyledHeader>
	);
};

export default Header;
